/* Sprint 7C/D: shared Section card wrapper.
 *
 * Visual port of the FuelEnquiryForm `Section` component (originally
 * defined inline at FuelEnquiryForm.js:1421) so the TradeRecap fuels
 * mode can render Deal Details / Contract & Partners / Commercial
 * Terms / Deal Makers cards with the same look as the enquiry and
 * bid/offer screens.
 *
 * Class names use the ``hms-section-*`` prefix instead of the
 * enquiry's ``fef-section-*`` so the two stylesheets cannot collide
 * (Solids recaps still mount the legacy ``trade-recap-section-card``
 * cards untouched).
 */
import React from 'react';
import './Section.css';

const Section = ({ title, children, stepNumber, anchorId, headerAction }) => (
  <section className="hms-section" id={anchorId}>
    <header className="hms-section-header">
      <h2 className="hms-section-title">
        {stepNumber !== undefined && (
          <span className="hms-section-number">{stepNumber}</span>
        )}
        {title}
      </h2>
      {headerAction}
    </header>
    <div className="hms-section-body">{children}</div>
  </section>
);

export default Section;
